import React from "react";
import { NavLink } from "react-router-dom";
import {
  X,
  Menu,
  Building2,
  Users,
  User,
  CreditCard,
  FileText,
  Settings,
  Milk,
  ClipboardList,
  FileSpreadsheet,
} from "lucide-react";

/**
 * Controlled sidebar: receives isOpen and onToggle from parent.
 * Scrolls properly with content even if table height grows.
 */
const CompanySidebar = ({ isOpen = true, onToggle }) => {
  const navItems = [
    { path: "/company-dashboard", label: "Dashboard", icon: <Building2 size={20} /> },
    { path: "/company/farmers", label: "Farmers", icon: <Users size={20} /> },
    { path: "/company/clients", label: "Clients", icon: <User size={20} /> },
    { path: "/company/employees", label: "Employees", icon: <Users size={20} /> },
    { path: "/company/marketplace", label: "Marketplace", icon: <Milk size={20} /> },
    { path: "/company/milk-journals", label: "Milk Journals", icon: <ClipboardList size={20} /> },
    { path: "/annotation-marketplace", label: "Annotation Hub", icon: <FileSpreadsheet size={20} /> },
    { path: "/company/payments", label: "Payments", icon: <CreditCard size={20} /> },
    { path: "/company/reports", label: "Reports", icon: <FileText size={20} /> },
    { path: "/company/settings", label: "Settings", icon: <Settings size={20} /> },
  ];

  return (
    <aside
      className={`flex flex-col bg-gradient-to-b from-cyan-800 to-cyan-700 text-white shadow-lg transition-all duration-300
        ${isOpen ? "w-64" : "w-20"}
        h-full max-h-screen overflow-y-auto`}
    >
      {/* Sidebar Header */}
      <div className="flex items-center justify-between px-4 py-4 border-b border-cyan-700 sticky top-0 bg-cyan-800 z-10">
        <h2
          className={`font-bold text-lg transition-all duration-300 ${
            isOpen ? "opacity-100" : "opacity-0 w-0 overflow-hidden"
          }`}
        >
          Company Panel
        </h2>
        <button onClick={onToggle} className="text-white hover:text-cyan-200 transition">
          {isOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Nav Links */}
      <nav className="flex-1 px-3 mt-4 space-y-2">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2 rounded-md transition-all duration-300 ${
                isActive
                  ? "bg-cyan-600 text-white shadow-md"
                  : "text-cyan-100 hover:bg-cyan-700 hover:text-white"
              }`
            }
          >
            <span className="shrink-0">{item.icon}</span>
            <span
              className={`whitespace-nowrap transition-all duration-300 ${
                isOpen ? "opacity-100" : "opacity-0 w-0 overflow-hidden"
              }`}
            >
              {item.label}
            </span>
          </NavLink>
        ))}
      </nav>

      {/* Footer */}
      <div className="text-center text-sm text-cyan-200 py-3 border-t border-cyan-700 sticky bottom-0 bg-cyan-800">
        <p className="flex items-center justify-center gap-2">
          <span className="text-pink-300">🤖</span>
          <span
            className={`transition-all duration-300 ${
              isOpen ? "opacity-100" : "opacity-0 w-0 overflow-hidden"
            }`}
          >
            Powered by Neuracraft AI
          </span>
          <span
            className={`transition-all duration-300 ${
              isOpen ? "hidden" : "inline"
            }`}
          >
            AI
          </span>
        </p>
      </div>
    </aside>
  );
};

export default CompanySidebar;
